import type { MotionProps } from 'framer-motion';

// Animación de entrada compartida (§5): fade-up suave al hacer scroll,
// una sola vez por sección.
export const fadeUp: MotionProps = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
  transition: { duration: 0.7, ease: 'easeOut' },
};
